import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'

// this is to adjust for the negative margins material ui uses
const HorizontalGridContainer = styled(Grid)`
  width: auto;
  padding-top: ${props => `${props.themespacing}`};
  padding-left: ${props => `${props.themespacing}`};
  align-items: center;
`

// if we need to customize spacing in between children, add a prop
const HorizontalGrid = ({ children }) => {
  const theme = useTheme()
  const themeSpaced = theme.spacing(0)

  return (
    <HorizontalGridContainer container spacing={2} themespacing={themeSpaced}>
      {children}
    </HorizontalGridContainer>
  )
}

HorizontalGrid.propTypes = {
  children: PropTypes.node.isRequired,
}

export default HorizontalGrid
